/* eslint-disable @typescript-eslint/no-explicit-any */
import { Yup } from '@frontman/utils';
import { CoverageCheckupState } from '../../store/step';

export const YesNoNotSureSchema = Yup.string()
  .required('please select an option')
  .oneOf(['yes', 'no', 'not_sure']);

export function createYesNoObjectSchema(
  fieldName: keyof CoverageCheckupState
): Yup.ObjectSchema<any> {
  return Yup.object().shape({ [fieldName]: YesNoNotSureSchema });
}
